import styled from "styled-components";
import yellowBg from "../../assets/images/yellow-bg.png";

//companions

export const CompanionsContainer = styled.section`
  width: 100%;
  margin-bottom: 17rem;
  h2 {
    font-size: 4.8rem;
    font-weight: 80rem;
    text-align: center;
    color: var(--primary-color);
    margin-bottom: 8.6rem;
    background: url(${yellowBg}) no-repeat 60% 50%;
    /* width: 200px; */
        @media (max-width: 560px) {
      font-size: 3.4rem;
    }
  }
`;

export const CompanionsCardContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > div:first-child {
    & > div {
      overflow-x: clip;
      overflow-y: unset;
      border-width: 2px;
      .swiper-wrapper {
        .swiper-slide {

        }
      }
      .swiper-pagination {
        bottom: -23px;
        & > span {
          border-radius: 2px;
          width: 30px;
        }
      }
    }
  }
  /* background-color: pink; */
`;

export const CompanionsImageContainer = styled.div`
  /* width: 23%; */
  padding: 0;
  img {
    /* width: 100%; */
    display: block;
    height: 450px;
    object-fit: contain;
    @media (max-width: 1150px) {
      display: none;
    }
  }
`;
export const CompanionsCardLeft = styled.div`
  width: 12%;
  background-color: var(--slider-bg);
  height: 380px;
  border-top: 2px dashed var(--border-slider);
  border-bottom: 2px dashed var(--border-slider);
  @media (max-width: 1150px) {
    display: none;
  }
  
`;

export const CompanionsCard = styled.div`
  width: 65%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--slider-bg);
  position: relative;

  .slider-wrapper {
    height: 380px;
    border-bottom: 2px dashed var(--border-slider);
    border-top: 2px dashed var(--border-slider);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center !important;
    overflow-x: clip;

    .swiper-slide {
      display: flex;
      justify-content: center;
      align-items: center;
      .arrow-wrapper-right {
        margin-top: 120px;
        margin-left: 40px;
      }
      .arrow-wrapper-left {
        margin-top: 120px;
        margin-right: 40px;
      }
      @media (max-width: 730px) {
        .arrow-wrapper-right {
          margin-left: 0px;
          margin-right: 0.4rem;
        }
        .arrow-wrapper-left {
          margin-right: 0px;
          margin-left: 0.4rem;
        }
      }
      .slider-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        & > p {
          color: var(--text-color);
          font-size: 1.4rem;
          font-weight: 50rem;
        }
        @media (max-width: 650px) {
          & > p {
            /* margin: 0; */
          }
        }
        @media (max-width: 453px) {
          & > p {
            margin-top: 0%;
          }
        }
      }
    }
    .swiper-pagination-bullet {
      background-color: var(--border-slider);
      width: 20px;
      height: 4px;
      z-index: 50;
      border-radius: 0;
      opacity: 1;
    }
    .swiper-pagination-bullet-active {
      background-color: var(--primary-color);
    }
  }
  h3 {
    color: #6bd7dd;
    font-size: 1.8rem;
    font-weight: 80rem;
    margin-bottom: 0.6rem;
    margin-top: 8rem;
    &.hoshio {
      color: #C1DFB3;
    }
  }

  .img-wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    height: 150px;
    width: 154px;
    top: -64px;
    /* border-bottom: 2px dashed var(--border-slider); */
    border-bottom-width: thick;
    border-width: 2px;
    border-radius: 50%;
    background-color: white;
    &.hoshio {
      img {
        width: 116px;
      }
    }
    &::after {
      position: absolute;
      content: url('Ellipse.svg');
      z-index: 10;
      top: 64px;
      left: -3px;
    }
  }
  /* div img{
    padding: 1rem;
    border-radius: 50%;
  }  */
  @media (max-width: 1150px) {
    width: 100%;
  }
`;
